module.exports = __webpack_public_path__ + "static/media/agribiz.464a5871.png";